<template>
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.07709 12.5921L12.2182 3.45095L10.9438 2.17649L1.80263 11.3176V12.5921H3.07709ZM3.82429 14.3947H0V10.5704L10.3066 0.263893C10.4756 0.0949226 10.7048 0 10.9438 0C11.1828 0 11.412 0.0949226 11.581 0.263893L14.1308 2.81372C14.2998 2.98274 14.3947 3.21195 14.3947 3.45095C14.3947 3.68995 14.2998 3.91916 14.1308 4.08818L3.82429 14.3947ZM0 16.1974H16.2237V18H0V16.1974Z"
            fill="currentColor" />
    </svg>
</template>
